import { BasicButton } from "@/components";
import Box from "@mui/material/Box";
import { Link, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/success")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<>
			<div className="container wrapper h-full bg-success">
				<Box className="h-full flex flex-col justify-center items-center">
					<img
						src="/images/icon-success.svg"
						alt="icon-success"
						loading="lazy"
					/>
					<h1 className="text-xl font-semibold text-center px-9 mt-6 mb-4">
						Your new password has been saved!
					</h1>
					<p className="text-sm text-gray-100 text-center mb-4">
						You can now sign in using your new password.
					</p>
					<Link to={"/"}>
						<BasicButton
							variant="contained"
							color="secondary"
							className="w-[93px] !h-12 !text-sm !shadow-none"
						>
							Done
						</BasicButton>
					</Link>
				</Box>
			</div>
		</>
	);
}
